module.exports = __webpack_public_path__ + "img/CTWP__Staff_03.1780be83.png";